import React from "react";

export const InsuranceState = () => {
  return <div>InsuranceState</div>;
};
